import { cn } from '@/utils/cn'

export type TabValue =
  | 'products'
  | 'summary'
  | 'financials'
  | 'analytics'
  | 'comments'

interface Tab {
  value: TabValue
  label: string
}

const TABS: Tab[] = [
  { value: 'products', label: 'Products' },
  { value: 'summary', label: 'Summary' },
  { value: 'financials', label: 'Financials' },
  { value: 'analytics', label: 'Analytics' },
  { value: 'comments', label: 'Comments' },
]

interface PlanDetailTabsProps {
  activeTab: TabValue
  onTabChange: (tab: TabValue) => void
}

export function PlanDetailTabs({
  activeTab,
  onTabChange,
}: PlanDetailTabsProps) {
  return (
    <div className="inline-flex w-fit rounded-lg border border-accent-border bg-accent p-1 ">
      {TABS.map(tab => (
        <button
          key={tab.value}
          onClick={() => onTabChange(tab.value)}
          className={cn(
            'px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer',
            'text-[#13254f]',
            activeTab === tab.value ? 'bg-white shadow-sm' : 'hover:bg-white/50'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
